/*
 * Copyright (c) 2022. Revo Digital
 * ---
 * Author: gabriele
 * File: project.ts
 * Project: mle-client-n
 * Committed last: 2022/6/22 @ 1610
 * ---
 * Description:
 */

import {MeasureUnits} from './enums';
import {measureUnitToMeasureUnit, pixelToMeasureUnit} from './measure-unit-utils';
import {Size2D} from "@revodigital/pamela/lib/common/Size2D";

export enum Orientations {
    PORTRAIT = "portrait",
    LANDSCAPE = "landscape"
}

export enum IsoSizes {
    A4 = 'A4',
    A5 = 'A5',
    A6 = 'A6',
    A7 = 'A7',
    A8 = 'A8',
    A9 = 'A9',
    A10 = 'A10',
}

export const isoSizesWithUm = (measureUnit: MeasureUnits, iso: IsoSizes): Size2D => {
    const info = isoSizesPixelDimensions[iso];
    return Size2D.fromBounds(pixelToMeasureUnit(measureUnit, info.width), pixelToMeasureUnit(measureUnit, info.height),)
}

/**
 * Dimensioni ISO standard dal A4 all'A10
 */
export const isoSizesPixelDimensions = {
    [IsoSizes.A4]: {
        width: 793,
        height: 1122
    },
    [IsoSizes.A5]: {
        width: 559,
        height: 793
    },
    [IsoSizes.A6]: {
        width: 396,
        height: 559
    },
    [IsoSizes.A7]: {
        width: 279,
        height: 396
    },
    [IsoSizes.A8]: {
        width: 196,
        height: 279
    },
    [IsoSizes.A9]: {
        width: 139,
        height: 196
    },
    [IsoSizes.A10]: {
        width: 98,
        height: 139
    }
} as {
    [key: string]: {
        width: number;
        height: number;
    }
};

/**
 * Returns the project dimension soil
 * @param measureUnit
 */
export const getProjectSoil = (measureUnit: MeasureUnits) => {
    return measureUnitToMeasureUnit(MeasureUnits.MM,
        measureUnit,
        50);
};